import { createSlice } from "@reduxjs/toolkit";

export const meetingReportsListSlice = createSlice({
  name: "meetingReportsList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedMeetingReport: null,
    filteredRecords: 0,
    isSingleMeetingReportLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllMeetingReportsLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleMeetingReportsLoadingState: (state, action) => {
      state.isSingleMeetingReportLoading = true;
    },
    loadAllMeetingReports: (state, action) => {
      const listObj = {};
      action.payload.meetingReports.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.meetingReports.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleMeetingReport: (state, action) => {
      state.selectedMeetingReport =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleMeetingReportLoading = false;
    },
  },
});

export const {
  setAllMeetingReportsLoadingState,
  setSingleMeetingReportsLoadingState,
  loadAllMeetingReports,
  loadSingleMeetingReport,
} = meetingReportsListSlice.actions;

export default meetingReportsListSlice.reducer;
